import React from 'react';
import PropTypes from 'prop-types';
import { getFaro } from 'flow/api-clients/faro-client';

import ErrorBoundaryView from 'flow/components/error-boundary/ErrorBoundaryView';
import { addGeneralLogEntry } from 'flow/utils/browser-utils';

class ErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, _info) {
        getFaro()?.api.pushError(error, {
            context: { component: 'default', severity: 'critical' },
        });
        addGeneralLogEntry(`Error reported: ${error}`);
    }

    onRetry = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return <ErrorBoundaryView onClick={this.onRetry} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
